import { render, staticRenderFns } from "./CompanyLogo.vue?vue&type=template&id=39d77cfb&scoped=true"
import script from "./CompanyLogo.vue?vue&type=script&lang=ts"
export * from "./CompanyLogo.vue?vue&type=script&lang=ts"
import style0 from "./CompanyLogo.vue?vue&type=style&index=0&id=39d77cfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d77cfb",
  null
  
)

export default component.exports